/* unplugin-vue-components disabled */import script from "./PolicyManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyManagement.vue?vue&type=script&setup=true&lang=js"

import "./PolicyManagement.vue?vue&type=style&index=0&id=23721407&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23721407"]])

export default __exports__